export default "__VITE_ASSET__XdrJU9In__"